<span
  class="route-stop-circle"
  *ngIf="stopType === 'O' || stopType === 'D'"
  [ngClass]="{
    origin: stopType === 'O',
    destination: stopType === 'D'
  }"
></span>
<span
  class="route-stop-number"
  [ngStyle]="{ 'border-color': routeColor }"
  *ngIf="stopType === 'S'"
  >{{ stopNumber }}</span
>
